import api from './api';

export const licenseService = {
  getAll: async (params = {}) => {
    const response = await api.get('/licenses', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/licenses/${id}`);
    return response.data;
  },

  create: async (licenseData) => {
    const response = await api.post('/licenses', licenseData);
    return response.data;
  },

  update: async (id, licenseData) => {
    const response = await api.put(`/licenses/${id}`, licenseData);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/licenses/${id}`);
    return response.data;
  },

  validate: async (licenseKey) => {
    const response = await api.get(`/public/validate/${licenseKey}`);
    return response.data;
  }
};
